<template>
  <v-select
    id="axis-select"
    v-model="filter.hierarquia"
    :items="axis"
    item-text="nome"
    item-value="usuarioGrupoId"
    placeholder="Grupos"
    @change="change"
    multiple
  >
    <template slot="no-data"> Nenhum Grupos retornado </template>
  </v-select>
</template>

<script>
import { groupsAPI } from "../API/groupsAPI";

export default {
  name: "AppAxisByProjectCombobox",
  props: ["filter"],
  mounted() {
    this.loadAxis();
  },
  methods: {
    loadAxis() {
      groupsAPI
        .get()
        .then((resp) => {
          this.axis = resp.data;
        })
        .catch();
    },
    change(val) {
      this.filter.hierarquia = val.map((item) => ({
        usuarioGrupoId: item,
      }));
    },
  },
  data() {
    return {
      axis: [],
    };
  },
};
</script>
